export const valori = {
  
  "pasta-al-pomodoro": {
    name : "Pasta with tomato sauce",
    co2: "0,20",
    proteine: "9,56",
    grassi: "11,46",
    carboidrati: "65,38",
    kcal: "387",
    saturi: "1,63",
    fibra: "2,79",
    km: '1,65'
  },
  "zuppa-contadina": {
    name : "Farmer’s soup",
    co2: "0,05",
    proteine: "10,16",
    grassi: "6,06",
    carboidrati: "36,97",
    kcal: "234",
    saturi: "0,81",
    fibra: "8,52",
    km: '0,42'
  },
  "lasagna": {
    name : "lasagna",
    co2: "1,15",
    proteine: "23,31",
    grassi: "21,28",
    carboidrati: "69,33",
    kcal: "545",
    saturi: "7,77",
    fibra: "3,12",
    km: '9,47'
  },
  "cous-cous":{
    name : "Vegetable couscous",
    co2: "0,25",
    proteine: "26",
    grassi: "14",
    carboidrati: "95",
    kcal: "610",
    saturi: "2",
    fibra: "17",
    km: '2,10'
  },
  "tortellini-alle-erbe": {
    name : "Herb-stuffed ravioli",
    co2: "0,64",
    proteine: "20,28",
    grassi: "19,17",
    carboidrati: "65,98",
    kcal: "501",
    saturi: "10,41",
    fibra: "3,51",
    km: '5,30'
  },
  "risotto-alla-milanese":{
    name : "risotto alla milanese",
    co2: "0,39",
    proteine: "8,99",
    grassi: "11,37",
    carboidrati: "65,57",
    kcal: "384",
    saturi: "6,81",
    fibra: "1",
    km: '3,43'
  },
  "pasta-e-broccoli":{
    name : "Pasta with broccoli",
    co2: "0,18",
    proteine: "11,72",
    grassi: "11,51",
    carboidrati: "66,38",
    kcal: "399",
    saturi: "1,63",
    fibra: "5,26",
    km: '1,52'
  },
  "pasta-e-fagioli":{
    name : "pasta e fagioli",
    co2: "0,15",
    proteine: "19,02",
    grassi: "12,13",
    carboidrati: "88,17",
    kcal: "516",
    saturi: "1,63",
    fibra: "11,01",
    km: '1,27'
  },
  "spaghetti-soia":{
    name : "Soy noodles with shrimp and veggies",
    co2: "1,03",
    proteine: "33",
    grassi: "13",
    carboidrati: "19",
    kcal: "292",
    saturi: "1",
    fibra: "6",
    km: '8,49'
  },
  "sushi":{
    name : "sushi",
    co2: "0,88",
    proteine: "46",
    grassi: "20",
    carboidrati: "66",
    kcal: "614",
    saturi: "7",
    fibra: "06",
    km: '7,19'
  },
  "riso-e-piselli":{
    name : "Rice and peas",
    co2: "0,23",
    proteine: "16,41",
    grassi: "11,21",
    carboidrati: "89,56",
    kcal: "502",
    saturi: "1,53",
    fibra: "8,85",
    km: '1,92'
  },
  "polpette-vegetali":{
    name : "polpette vegetali",
    co2: "0,19",
    proteine: "13",
    grassi: "10",
    carboidrati: "18",
    kcal: "205",
    saturi: "2,61",
    fibra: "5,41",
    km: '1,57'
  },
  "hamburger":{
    name : "hamburger",
    co2: "1,74",
    proteine: "20,5",
    grassi: "11,99",
    carboidrati: "0",
    kcal: "190",
    saturi: "2,93",
    fibra: "0",
    km: '21,17'
  },
  "petto-di-pollo":{
    name : "Chicken breast",
    co2: "0,38",
    proteine: "23,85",
    grassi: "5,83",
    carboidrati: "3,86",
    kcal: "162",
    saturi: "0,98",
    fibra: "0,11",
    km: '3,16'
  },
  "merluzzo":{
    name : "Cod",
    co2: "0,48",
    proteine: "16",
    grassi: "15",
    carboidrati: "21",
    kcal: "276",
    saturi: "4,48",
    fibra: "4,3",
    km: '3,93'
  },
  "tortini-di-verdure":{
    name : "Veggie pie",
    co2: "0,39",
    proteine: "16",
    grassi: "15",
    carboidrati: "21",
    kcal: "276",
    saturi: "4,48",
    fibra: "4,3",
    km: '3,20'
  },
  "frittata":{
    name : "frittata",
    co2: "0,41",
    proteine: "15",
    grassi: "20",
    carboidrati: "0",
    kcal: "243",
    saturi: "5,25",
    fibra: "0",
    km: '3,40'
  },
  "hummus-vegetale":{
    name : "Hummus with veggies",
    co2: "0,11",
    proteine: "16",
    grassi: "24",
    carboidrati: "29",
    kcal: "401",
    saturi: "4",
    fibra: "10",
    km: '0,94'
  },
  "fagioli-all-uccelletto":{
    name : "Tuscan baked beans",
    co2: "0,16",
    proteine: "15",
    grassi: "12",
    carboidrati: "36",
    kcal: "304",
    saturi: "1,45",
    fibra: "13",
    km: '1,35'
  },
  "mozzarella":{
    name : "mozzarella",
    co2: "0,82",
    proteine: "18,7",
    grassi: "19,7",
    carboidrati: "0,7",
    kcal: "178",
    saturi: "11,43",
    fibra: "0",
    km: '6,70'
  },
  "prosciutto":{
    name : "prosciutto",
    co2: "0,79",
    proteine: "12,75",
    grassi: "9,2",
    carboidrati: "0",
    kcal: "134",
    saturi: "6,15",
    fibra: "0",
    km: '6,50'
  },
  "insalata":{
    name : "salad",
    co2: "0,03",
    proteine: "0,9",
    grassi: "5,19",
    carboidrati: "1,1",
    kcal: "51",
    saturi: "0,73",
    fibra: "0,75",
    km: '0,30'
  },
  "patate-al-forno":{
    name : "Oven-baked potatoes",
    co2: "0,06",
    proteine: "3,15",
    grassi: "11,49",
    carboidrati: "26,85",
    kcal: "204",
    saturi: "1,45",
    fibra: "2,4",
    km: '0,43'
  },
  "zucchine":{
    name : "zucchini",
    co2: "0,17",
    proteine: "2,6",
    grassi: "10,19",
    carboidrati: "2,8",
    kcal: "102",
    saturi: "1,45",
    fibra: "2,4",
    km: '1,28'
  },
  "spinaci":{
    name : "spinach",
    co2: "0,10",
    proteine: "6,8",
    grassi: "11,39",
    carboidrati: "5,8",
    kcal: "124",
    saturi: "1,45",
    fibra: "3,8",
    km: '0,69'
  },
  "banana":{
    name : "banana",
    co2: "0,12",
    proteine: "1,8",
    grassi: "0,45",
    carboidrati: "23,1",
    kcal: "99,6",
    saturi: "0",
    fibra: "2,7",
    km: '1'
  },
  "ananas":{
    name : "Pineapple",
    co2: "0,08",
    proteine: "0,75",
    grassi: "0",
    carboidrati: "15",
    kcal: "63",
    saturi: "0",
    fibra: "1,5",
    km: '0,67'
  },
  "arancia":{
    name : "Orange",
    co2: "0,04",
    proteine: "1,05",
    grassi: "0,3",
    carboidrati: "11,7",
    kcal: "51",
    saturi: "0",
    fibra: "2,4",
    km: '0,37'
  },
  "mela":{
    name : "Apple",
    co2: "0,03",
    proteine: "0,45",
    grassi: "0,15",
    carboidrati: "20,55",
    kcal: "84",
    saturi: "0",
    fibra: "3"
  },
  "pera":{
    name : "Pear",
    co2: "0,04",
    proteine: "0,45",
    grassi: "0,15",
    carboidrati: "13,2",
    kcal: "54,6",
    saturi: "0",
    fibra: "5,7",
    km: '0,33'
  }
  
}